export const civilStatus = ["Single", "Married", "Prefer not to say"];

export const civilStatusOptions = civilStatus.map((civilStatus) => ({
  value: civilStatus,
  label: civilStatus,
}));
